export const SYNC_DELIVERIES_TABLE_MS = 20000

export const LANG = {
  UNEXPECTED_ERROR: 'An unexpected error occurred',
  FAILED_TO_FETCH_DELIVERIES: 'Failed to fetch deliveries',
  FAILED_TO_ASSIGN_VEHICLE_DRIVER: 'Failed to assign vehicle / driver',
  FAILED_TO_SUBMIT_BATCH_OPERATION: 'Failed to submit batch operation'
}

export const DELIVERY_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
  DISPATCHED: 'dispatched',
  IN_TRANSIT: 'in_transit',
  COMPLETE: 'complete',
  CANCELLED: 'cancelled',
  RESCHEDULED: 'rescheduled',
  FAILED: 'failed'
}

export const DELIVERY_STATUS_LABELS = {
  [DELIVERY_STATUS.PENDING]: 'Pending',
  [DELIVERY_STATUS.READY]: 'Ready',
  [DELIVERY_STATUS.DISPATCHED]: 'Dispatched',
  [DELIVERY_STATUS.IN_TRANSIT]: 'In Transit',
  [DELIVERY_STATUS.COMPLETE]: 'Complete',
  [DELIVERY_STATUS.CANCELLED]: 'Cancelled',
  [DELIVERY_STATUS.RESCHEDULED]: 'Rescheduled',
  [DELIVERY_STATUS.FAILED]: 'Failed'
}

export const VERIFICATION_STATUS = {
  VERIFIED: 'Verified',
  UNVERIFIED: 'Un-Verified'
}
